import React, { Children } from "react";
import { Box } from "../Box/Box";
import { ResponsiveSpace } from "../Box/useBoxStyles";
import { ReactNodeNoStrings } from "../private/ReactNodeNoStrings";
import {
  Align,
  alignToFlexAlign,
  alignYToFlexAlign,
  AlignY,
} from "../utils/align";
import {
  negativeMarginLeft,
  negativeMarginTop,
} from "../utils/negativeMarginCss";
import { ResponsiveProp } from "../utils/responsiveProp";

export interface InlineProps {
  align?: ResponsiveProp<Align>;
  alignY?: ResponsiveProp<AlignY>;
  space: ResponsiveSpace;
  children: ReactNodeNoStrings;
  wrap?: boolean;
}

export const Inline = ({
  space = "none",
  align,
  alignY,
  children,
  wrap = true,
}: InlineProps): React.ReactElement => {
  const [lmClassName, lmCss] = negativeMarginLeft(space);
  const [tmClassName, tmCss] = negativeMarginTop(space);

  return (
    <Box className={tmClassName}>
      {lmCss}
      {tmCss}
      <Box
        display="flex"
        justifyContent={alignToFlexAlign(align)}
        alignItems={alignYToFlexAlign(alignY)}
        flexWrap={wrap ? "wrap" : "nowrap"}
        className={lmClassName}
      >
        {Children.map(children, (child) =>
          child !== null && child !== undefined ? (
            <Box minWidth={0} paddingLeft={space} paddingTop={space}>
              {child}
            </Box>
          ) : null,
        )}
      </Box>
    </Box>
  );
};
